export enum SessionStorageKeysEnum {
  ACCESS_TOKEN_SESSION = "accessToken",
  REFRESH_TOKEN_SESSION = "refreshToken",
  SELECTED_OUTSOURCED_WORKER = "selectedOutsourcedWorker",
  SELECTED_ORDER_SERVICE = "selectedOrderService",
  SCHEDULE_SNACKBAR_MESSAGE = "scheduleSnackbarMessage",
}
